import React from 'react'

function Analytics_card({num,name,icon,classIcon}) {
    return (
        <div className="card_statistic shadow_main" >
            <div className="card_statistic_top" >
                <i className={`${icon} ${classIcon}`}></i>
            </div>
            <div>
                <p className="card_statistic_num" >{num}</p>
                <p className="card_statistic_p">{name}</p>
            </div>
        </div>
    )
}

export default Analytics_card